import { graphql, useStaticQuery } from "gatsby"
import type { PageAnalyticsConfiguration } from "~/lib/pageAnalytics"

type CustomUrl = {
  url: string
  productArea: string | null
  productSection: string | null
}

type Query = {
  GraphCmsSquidex: {
    findPageAnalyticsConfigurationSingleton: {
      flatData: {
        applicationName: string | null
        customUrls: CustomUrl[] | null
      }
    } | null
  }
}

export default function usePageAnalyticsConfigurationQuery(): PageAnalyticsConfiguration {
  const { GraphCmsSquidex } = useStaticQuery<Query>(graphql`
    {
      GraphCmsSquidex {
        findPageAnalyticsConfigurationSingleton {
          flatData {
            applicationName
            customUrls {
              url
              productArea
              productSection
            }
          }
        }
      }
    }
  `)

  const flatData =
    GraphCmsSquidex.findPageAnalyticsConfigurationSingleton?.flatData

  return {
    applicationName: flatData?.applicationName ?? null,
    customUrls: flatData?.customUrls ?? [],
  }
}
